import Button from 'components/form/Button'
import { updateOnOffStatus } from 'features/dashboard/operation/onOff/onOffSlice'
import { batch, useDispatch, useSelector } from 'react-redux'
import { refreshDashboard } from 'features/dashboard/dashboardCommonSlice'
import { success, fail } from 'features/toast/Toast'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { DashboardTypeDTOs, DashboardTypes } from 'features/Codes'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'
import { useDashboardTypeName } from 'features/dashboard/utils/hooks/useDashboardTypeName'

export const getStatusMap = (payload, type) => {
  const dto = DashboardTypeDTOs[type]
  const result = payload[dto]
  return type === DashboardTypes.CAMPAIGN
    ? result
    : result.reduce((acc, cur) => {
        acc[cur.id] = cur.status
        return acc
      }, {})
}

const OnOffButtons = () => {
  const dispatch = useDispatch()
  const { selectedIds } = useDashboardTableSelector()
  const { setStatus, setSelectedIds } = useDashboardTableActions()
  const { type, name } = useDashboardTypeName()
  const { isSubmitting } = useSelector(state => state.dashboard.operation.onOff)
  const nonSelected = selectedIds.length < 1

  const setOnOff = async status => {
    const { payload, error } = await dispatch(
      updateOnOffStatus({
        type,
        status,
        ids: selectedIds,
      })
    )
    if (error) {
      fail(`${name} 변경사항을 적용할 수 없습니다.`)
    } else {
      const statusMap = getStatusMap(payload, type)
      dispatch(setStatus(statusMap))
      success(`${name} 변경사항이 적용되었습니다.`)
      batch(() => {
        dispatch(setSelectedIds([]))
        dispatch(refreshDashboard())
      })
    }
  }

  const handleSetOn = () => setOnOff('ON')
  const handleSetOff = () => setOnOff('OFF')

  return (
    <div className="couple_btn">
      <Button disabled={nonSelected || isSubmitting} onClick={handleSetOn}>
        ON
      </Button>
      <Button disabled={nonSelected || isSubmitting} onClick={handleSetOff}>
        OFF
      </Button>
    </div>
  )
}
export default OnOffButtons
